import type { QueryKey } from "react-query";

const storageProviderFilesKey = (): QueryKey => "storageProviderFiles";

export { storageProviderFilesKey };
